import { Button, PaginationProps } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

export const CustomPaginationItem: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return (
      <Button className="text-sm text-black" style={{ borderColor: "#D8DAE5" }}>
        <ArrowLeftOutlined />
        Previous
      </Button>
    );
  }
  if (type === "next") {
    return (
      <Button className="text-sm text-black" style={{ borderColor: "#D8DAE5" }}>
        Next
        <ArrowRightOutlined />
      </Button>
    );
  }
  return originalElement;
};
